import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURlMapping = {
  drmBidTableData: URLS.DRM_BID_TABLE_DETAILS,
  drmDailyTableData: URLS.DRM_DAILY_TABLE_DETAILS,
};

export const fetchDrmExcelData = async ([reqBody, totalPages, tableName]) => {
  const pageSize = 1000;
  const url = tableURlMapping[tableName];
  
  if (!url) {
    throw new Error(`Invalid table name: ${tableName}`);
  }

  let allData = {
    status: "200",
    message: "",
    details: {
      onPage: 1,
      pageSize: 0,
      data: [],
      totalPages:0,
      totalRecords: 0,
    },
  };

  try {
    for (let i = 1; i <= totalPages; i++) {
      const response = await axios.post(
        `${url}?pageNum=${i}&pageSize=${pageSize}`,
        reqBody
      );
      
      if (response.status === 200) {
        const { details } = response.data;
        allData.details.pageSize += details.pageSize;
        allData.details.data.push(...details.data);
        allData.details.totalRecords = details.totalRecords;
      } else {
        throw new Error(`Request failed with status ${response.status}`);
      }
    }
    
    return allData;
  } catch (error) {
    return {
      status: "error",
      message: error.message,
      details: {
        ...allData.details,
        data: [],
      },
    };
  }
};